export const EDIT_PROFILE = 'EDIT_PROFILE';
export const USER_AUTHENTICATED = 'USER_AUTHENTICATED';
export const SET_PROFILE_DATA = 'SET_PROFILE_DATA';
export const RECEIVE_WORKOUTS = 'RECEIVE_WORKOUTS';
export const RECEIVE_WORKOUT_DATA = 'RECEIVE_WORKOUT_DATA';
export const INITIALIZE_WORKOUT_PAGE_DATA = 'INITIALIZE_WORKOUT_PAGE_DATA';
export const UPDATE_GRAPH_MARKER = 'UPDATE_GRAPH_MARKER';
export const UPDATE_LAPS = 'UPDATE_LAPS';
export const FOCUS_ON_LAP = 'FOCUS_ON_LAP';
